import SBox from 'components/opinionless/SBox'
import { SStyled } from '../../../styles/theme'

export const StaticTableHeader = SStyled.th`
    &:hover {
        cursor: pointer;
    }
    text-align: center;
    font-weight: bold;
    height: 36px;
    max-height: 36px;
    color: #6C6C6C;
    padding: 10px;
    font-size: 14px;
`

export const StaticTableRow = SStyled.tr`
    background: white;
    text-align: left;
    border-bottom: 1px solid black;
    color: #6C6C6C;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    padding: 10px;
`

export const StaticTableData = SStyled.td`
    padding: 10px;
`

export const StaticTableHeaderContainer = SStyled(SBox)`
    
    background-color: #F7F8F8;
    padding: 10px;
    border-radius: 8px;
    flexDirection: row;
    flex: 1;
`
